import { paymentState } from "@1-now/booking-core";

/**
 * A pay-later reservation with nothing paid on it yet (1NOW-11198). Its booking page leaves out Edit Booking and
 * the renter's other bookings until it is paid; everything else on the page (the invoice, what is due, ID and
 * insurance) stays.
 *
 * Read from the booking itself, not from the way the renter got to the page (the reservation, Track my booking, a
 * link): a card booking, a paid reservation and a partly paid one are not this, and show as they always have.
 */
export const reservationUnpaid = (booking: any): boolean =>
  booking?.pay_later === true && paymentState(booking).status === "un-paid";
